import { createContext, useContext } from "react";

import type {
  Product,
  ProductCategory,
  ProductModifier,
  ProductModifierGroup,
} from "~/providers/product-provider";

interface ProductContext {
  products: Product[];
  modifiers: ProductModifier[];
  modifierGroups: ProductModifierGroup[];
  productCategories: ProductCategory[];
}

export const ProductContext = createContext<ProductContext | undefined>(
  undefined,
);

export const useProduct = () => {
  const context = useContext(ProductContext);
  if (context === undefined) {
    throw new Error("useProduct must be used within a ProductProvider");
  }

  return context;
};
